module.exports = __webpack_public_path__ + "static/4-cbaf1c2e7266d400d12fa49d1de05565.jpeg";